import React from "react";
import "./bottom-message.css";

import FaCheck from "../../assets/images/pop-up-message/check.png";
import FaInfo from "../../assets/images/pop-up-message/info.png";
import FaWarning from "../../assets/images/pop-up-message/warning.png";
import FaQuestion from "../../assets/images/pop-up-message/question.png";
import FaError from "../../assets/images/pop-up-message/close.png";
import FaMinus from "../../assets/images/pop-up-message/minus.png";
import FaPhone from "../../assets/images/pop-up-message/phone.png";
import { useTranslation } from 'react-i18next';

const StickyBottomMessage = ({ message, type, isVisible, onClose, style = null }) => {
  // Define icons for different message types
  const messageTypes = {
    success: { icon: <img src={FaCheck} alt="Success Icon" /> },
    error: { icon: <img src={FaError} alt="Error Icon" /> },
    info: { icon: <img src={FaInfo} alt="Info Icon" /> },
    warning: { icon: <img src={FaWarning} alt="Warning Icon" /> },
    question: { icon: <img src={FaQuestion} alt="Question Icon" /> },
    minus: { icon: <img src={FaMinus} alt="Minus Icon" /> },
    phone: { icon: <img src={FaPhone} alt="Phone Icon" /> },
  };

  const { icon } = messageTypes[type];
  const { t } = useTranslation();

  const errHeading = {
    success: t("common.success"),
    error: t("common.error"),
    info: t("common.info"),
    warning: t("common.warning"),
    question: t("common.question"),
    minus: t("common.minus"),
    phone: t("common.phone"),
  }

  return (
    <>
      <div
        className={`sticky-overlay ${isVisible ? "visible" : ""}`}
        onClick={onClose}
      ></div>

      <div 
        className={`sticky-bottom-message ${isVisible ? "" : "hidden"}`}
        style={style}
      >
        <div className="sticky-plan-header">
          <div className="sticky-message-icon">{icon}</div>
          <div className="sticky-plan-info">
            <p className="sticky-plan-name">
              {errHeading[type]}
            </p>
            <p style={{ whiteSpace: "pre-line" }} className="sticky-formatted-text" dangerouslySetInnerHTML={{ __html: message }} />
          </div>
        </div>
        <div className="sticky-button-container">
          <button className="sticky-proceed-button" onClick={onClose}>
            {`${t("common.yes")}`}
          </button>
        </div>
      </div>
    </>
  );
};

export default StickyBottomMessage;